/** Unsplash photo id (časť za `photo-`) — rovnaké parametre ako pri kartách miest */
export function unsplashImageSrcSet(photoId: string): { src: string; srcSet: string } {
  const base = `https://images.unsplash.com/photo-${photoId}`;
  const q = 'auto=format&fit=crop&q=85';
  return {
    src: `${base}?${q}&w=1200&h=800`,
    srcSet: `${base}?${q}&w=800&h=533 800w, ${base}?${q}&w=1200&h=800 1200w, ${base}?${q}&w=1600&h=1067 1600w`,
  };
}
